import { LoginModal } from "../loginModal";
import LikedIcon from "../../assets/likedIcon.svg";
import { openLink } from "../../services/openLink";
import { useState, useRef, useEffect } from "react";
import { reactions } from "../../services/reactions";
import { useAuth } from "../../context/authProvider";
import UnlikedIcon from "../../assets/unlikedIcon.svg";
import { GetQualifiedModal } from "../getQualifiedModal";
import PassIcon from "../../assets/Matching/passIcon.svg";
import LikeIcon from "../../assets/Matching/likeIcon.svg";
import { CartIcon } from "../../assets/BottomBar/CartIcon";
import CheckIconQual from "../../assets/checkIconQual.svg";
import ListingXbutton from "../../assets/listingXButton.svg";
import { useUserProfileStore } from "../../stores/profileStore";
import { useShowLoginModalStore } from "../../stores/loginModalStore";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetQualifiedModalStore } from "../../stores/getQualifiedStore";
import { LoadingCircle } from "../common";

const ListingViewIframe = () => {
	const { zlid } = useParams<{ zlid: string }>();
	const { isWebview } = useAuth();
	const navigate = useNavigate();
	const buttonContainerRef = useRef<HTMLDivElement | null>(null);
	const location = useLocation();
	const origin = location.state?.origin;
	const [inCart, setInCart] = useState(false);
	const [addedToCart, setAddedToCart] = useState(false);
	const [liked, setLiked] = useState(false);
	const { userProfile } = useUserProfileStore();
	const [buttonDisabled, setButtonDisabled] = useState(false);
	const { showLoginModal } = useShowLoginModalStore();
	const { showGetQualifiedModal } = useGetQualifiedModalStore();
	const mlsNumber = zlid?.slice(4);
	const [iframeLoaded, setIframeLoaded] = useState(false);
	const [childListingId, setChildListingId] = useState<string>();
	const [vendor, setVendor] = useState<string>();
	const [showBottomButton, setShowBottomButton] = useState(true);
	const iframeRef = useRef<HTMLIFrameElement>(null);

	useEffect(() => {
		if (vendor && childListingId) {
			const prefix =
				vendor === "ITSO" ? "1017" : vendor === "TRREB" ? "1002" : "";
			if (prefix) {
				const newZlid = prefix + childListingId;
				const newUrl = `${window.location.origin}/?zlid=${newZlid}`;
				window.history.replaceState({}, "", newUrl);
			}
		}
	}, [vendor, childListingId]);

	const handlePass = async () => {
		if (!zlid) {
			console.error("ZLID is undefined");
			return;
		}

		try {
			await reactions(zlid, "SWIPE_LEFT_TO_DISLIKE_LISTING");
			navigate(-1);
		} catch (error) {
			console.error("Failed to record left swipe reaction", error);
			navigate(-1);
		}
	};

	const handleLike = async () => {
		if (!zlid) {
			console.error("ZLID is undefined");
			return;
		}

		try {
			const response = await reactions(zlid, "SWIPE_RIGHT_TO_LIKE_LISTING");

			if (response?.inCart) {
				setInCart(response?.inCart);
				setAddedToCart(!response?.inCart);
				return;
			}

			navigate(-1);
		} catch (error) {
			console.error("Failed to record right swipe reaction", error);
			navigate(-1);
		}
	};
	useEffect(() => {
		const isLiked = userProfile?.likedHomes?.some(
			(home) => home.listingId === zlid,
		);
		setLiked(!!isLiked);
	}, [userProfile, zlid]);

	const handleAddtoCart = async () => {
		if (!zlid) {
			console.error("ZLID is undefined");
			return;
		}

		try {
			setButtonDisabled(true);
			const response = await reactions(zlid, "SWIPE_RIGHT_TO_LIKE_LISTING");
			setButtonDisabled(false);
			if (response?.inCart) {
				setInCart(true);
				return;
			}

			setAddedToCart(true);
		} catch (error) {
			console.error("Failed to add to cart", error);
		}
	};

	const handleAddToSavedProperties = async () => {
		if (!zlid) {
			console.error("ZLID is undefined");
			return;
		}
		try {
			await reactions(zlid, "SAVE_LISTING");

			if (liked) {
				await reactions(zlid, "REMOVE_SAVED_LISTING");
				setLiked(false);
			} else if (!liked) {
				await reactions(zlid, "SAVE_LISTING");
				setLiked(true);
			}
		} catch (error) {
			console.error("Failed to add to cart", error);
		}
	};
	const [iframeHeight, setIframeHeight] = useState(0);
	const [galleryOpened, setGalleryOpened] = useState(false);
	useEffect(() => {
		const measure = () => {
			const btnH = buttonContainerRef.current?.offsetHeight ?? 0;
			const topInset = window.bridge?.adjustedContentInset.top ?? 0;
			const bottomInset = window.bridge?.adjustedContentInset.bottom ?? 0;
			setIframeHeight(
				window.innerHeight -
					btnH -
					topInset +
					bottomInset -
					(galleryOpened || !showBottomButton ? 0 : 15),
			);
		};

		measure();
		window.addEventListener("resize", measure);
		return () => window.removeEventListener("resize", measure);
	}, [galleryOpened, showBottomButton]);

	useEffect(() => {
		if (iframeRef.current) {
			iframeRef.current.src = `https://zown.ca/${mlsNumber}`;
		}
		setIframeLoaded(false);
	}, [mlsNumber]);

	useEffect(() => {
		const handleMessage = (e: MessageEvent) => {
			const msgType = e.data?.type;
			switch (msgType) {
				case "PAGE_LOADED": {
					setIframeLoaded(true);
					setGalleryOpened(false);
					setShowBottomButton(true);
					break;
				}
				case "GALLERY_OPENED": {
					setGalleryOpened(true);
					break;
				}
				case "GALLERY_CLOSED": {
					setGalleryOpened(false);
					break;
				}
				case "listing_id":
					setChildListingId(e.data.listingId);
					break;
				case "vendor":
					setVendor(e.data.vendor);
					break;
				case "CMA_PAGE_LOADED": {
					setIframeLoaded(true);
					setGalleryOpened(true);
					setShowBottomButton(false);
					break;
				}
				default:
					break;
			}
		};

		window.addEventListener("message", handleMessage);
		return () => window.removeEventListener("message", handleMessage);
	}, []);

	const xbuttonPadding = window.bridge
		? window.bridge.adjustedContentInset.top + 10
		: 12;

	const calendlyUrl =
		"https://calendly.com/d/cmww-xkc-9gs/zown-property-information-meeting";
	const encoded = encodeURIComponent(calendlyUrl);
	const href = `https://zown.ca/calendly?link=${encoded}&send=false`;
	return (
		<div className="h-full text-black overflow-hidden">
			<div className="relative overflow-hidden">
				{!galleryOpened && (
					<button
						type="button"
						className="fixed top-0 w-[100px] h-[100px] flex items-start drop-shadow-md justify-end z-20 pr-6 right-0"
						style={{
							paddingTop: `${xbuttonPadding}px`,
						}}
						onClick={() => {
							const currentUrl = window.location.href;
							const searchParams = new URLSearchParams(window.location.search);
							const pathParts = window.location.pathname
								.split("/")
								.filter(Boolean);
							const firstPart = pathParts.length > 0 ? pathParts[0] : null;

							if (currentUrl.includes("?zlid=") && isWebview) {
								const zlid = searchParams.get("zlid");

								if (zlid) {
									const fullUrl = firstPart
										? `${window.location.origin}/${firstPart}/`
										: `${window.location.origin}/`;

									window.history.replaceState({}, "", fullUrl);
								}

								navigate("/explore");
							} else {
								const fullUrl = firstPart
									? `${window.location.origin}/${firstPart}/`
									: `${window.location.origin}/`;

								window.history.replaceState({}, "", fullUrl);
								navigate(-1);
							}
						}}
					>
						<img src={ListingXbutton} alt="" className="w-10 h-10" />
					</button>
				)}
				<div className="relative overflow-hidden">
					{!iframeLoaded && (
						<div className="absolute inset-0 z-40 flex items-center justify-center bg-white">
							<LoadingCircle />
						</div>
					)}
					<iframe
						ref={iframeRef}
						src={`https://zown.ca/${mlsNumber}`}
						className={`${isWebview ? "" : "pt-bridge-inset-top"} w-full`}
						style={{
							height: `${iframeHeight}px`,
						}}
						title="ListingDetail"
					/>
				</div>
			</div>
			{!galleryOpened && showBottomButton && (
				<>
					{!isWebview && (
						<>
							{origin === "matchingListing" && (
								<div
									ref={buttonContainerRef}
									className={`fixed flex w-full justify-center space-x-4 z-30 ${
										window.bridge ? "bottom-bridge-inset-bottom" : "bottom-4"
									}`}
								>
									<button
										type="button"
										className="drop-shadow-lg w-[85px] h-[85px] rounded-full"
										onClick={handlePass}
									>
										<img src={PassIcon} alt="Pass" />
									</button>
									<button
										type="button"
										className="drop-shadow-lg w-[85px] h-[85px] rounded-full"
										onClick={handleLike}
									>
										<img src={LikeIcon} alt="Like" />
									</button>
								</div>
							)}
							{origin !== "matchingListing" && (
								<div
									ref={buttonContainerRef}
									className={`fixed flex items-center gap-2 w-full justify-center px-6 z-30 ${
										window.bridge ? "bottom-bridge-inset-bottom" : "bottom-4"
									}`}
								>
									<button
										onClick={handleAddtoCart}
										type="button"
										disabled={buttonDisabled}
										className={`${inCart || addedToCart ? "bg-z-abbey text-black" : "bg-z-dark-moss-green text-white"} shadow-lg disabled:bg-[#D9D9D9] flex items-center gap-2 justify-center py-5 font-bold w-full rounded-full`}
									>
										<CartIcon
											fill={inCart || addedToCart ? "#32302F" : "#FFFFFF"}
										/>
										{inCart
											? "Already added to showing cart"
											: addedToCart
												? "Added to showing cart"
												: "Add to showing cart"}
									</button>
									<button
										type="button"
										className="rounded-full drop-shadow-lg"
										onClick={handleAddToSavedProperties}
									>
										<img src={liked ? LikedIcon : UnlikedIcon} alt="" />
									</button>
								</div>
							)}
						</>
					)}

					{isWebview && (
						<div
							ref={buttonContainerRef}
							className={`fixed flex items-center gap-2 w-full justify-center px-6 z-30 ${
								window.bridge ? "bottom-bridge-inset-bottom" : "bottom-4"
							}`}
						>
							<button
								onClick={() => openLink(href)}
								type="button"
								className="bg-z-dark-moss-green text-white shadow-lg disabled:bg-[#D9D9D9] flex items-center gap-2 justify-center py-5 font-bold w-full rounded-full"
							>
								<img src={CheckIconQual} alt="" />
								Schedule a Call
							</button>
						</div>
					)}
				</>
			)}
			{showGetQualifiedModal && isWebview && !showLoginModal && (
				<GetQualifiedModal />
			)}
			{showLoginModal && isWebview && <LoginModal />}
		</div>
	);
};

export { ListingViewIframe };
